import { supabase } from './supabaseClient';

// RxK's product line, read from core_products (brand = 'rxk') so a new RxK
// SKU added in ERP shows up in the admin without code changes. Cached for
// the session; the gift box is always included.
let cached: Promise<string[]> | null = null;

export function getRxkSkus(): Promise<string[]> {
  if (!cached) {
    cached = Promise.resolve(
      supabase
        .from('core_products')
        .select('sku')
        .eq('brand', 'rxk')
        .then(({ data, error }) => {
          if (error) cached = null;
          const skus = ((data as { sku: string }[]) ?? []).map((r) => r.sku);
          return skus.includes('GIFT-BOX') ? skus : [...skus, 'GIFT-BOX'];
        }),
    );
  }
  return cached;
}
